import React, { useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import {
  Box,
  Button,
  Divider,
  Drawer,
  Grid,
  IconButton,
  Typography,
  TablePagination,
  Snackbar,
  Alert,
  Pagination,
  Skeleton,
  Tooltip,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "../jumpstart.css";
import Checkbox from "@mui/material/Checkbox";
import RefreshIcon from "@mui/icons-material/Refresh";
import StyledTableCell from "../commonComponents/styledTableCell";
import {
  JsOrangeContainedBtn,
  JsTextAsButton,
} from "../../../components/buttons";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import GenerateSitelinks from "./generateSitelinks";
import UpdateSitelink from "./updateSitelink";
import {
  fetchSitelinks,
  generateSitelinks,
  saveSitelinks,
  fetchBusinessDetailsByJsAccountId,
} from "../../../actions/jumpstartRevamped";
import "../jumpstart.css";
function Sitelinks(props) {
  const {
    id,
    token,
    fetchSitelinks,
    fetchSitelinksReducer,
    generateSitelinks,
    generateSitelinksReducer,
    saveSitelinksReducer,
    saveSitelinks,
    fetchBusinessDetailsByJsAccountId,
    fetchBusinessDetailsByJsAccountIdReducer,
    jsAccId,
    disableStructure,
  } = props;

  const [sitelinks, setSitelinks] = useState([]);
  const [productFocus, setProductFocus] = useState("");
  const [url, setUrl] = useState("");

  //selected sitelinks
  const [selectedSitelinks, setSelectedSitelinks] = useState([]);

  const [isOpen, setIsOpen] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  //selected sitelink for editing
  const [selectedSitelinkForEdit, setSelectedSitelinkForEdit] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);


  //Snackbar
  const [snackbarMsg, setSnackbarMsg] = useState();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [error, setError] = useState(false);

  //Generate Snackbar
  const [generateError, setGenerateError] = useState(false);
  const [generateSnackbarMsg, setGenerateSnackbarMsg] = useState();
  const [generateSnackbarOpen, setGenerateSnackbarOpen] = useState(false);

  const [totalPages, setTotalPages] = useState(0);

  const [brandName, setBrandName] = useState("");

  useEffect(() => {
    if (sitelinks && sitelinks.length > 0) {
      const indexOfLastItem = page * rowsPerPage;
      const indexOfFirstItem = indexOfLastItem - rowsPerPage;
      const currentItems = sitelinks.slice(indexOfFirstItem, indexOfLastItem);
      setTotalPages(Math.ceil(sitelinks.length / rowsPerPage));
    }
  }, [sitelinks]);

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setError(false);
    setSnackbarOpen(false);
  };

  const handleGenerateSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setGenerateError(false);
    setGenerateSnackbarOpen(false);
  };

  const fetchSitelinksData = async () => {
    setLoading(true);
    const data = await fetchSitelinks(token, id);
    if (data && data.status == 200) {
      const { status, ...sitelinksData } = data;
      const allSitelinks = Object.values(sitelinksData);
      setSitelinks(allSitelinks);
      const saveSelectedCallouts = allSitelinks.filter(
        (sitelink) => sitelink.selected
      );
      setSelectedSitelinks(saveSelectedCallouts);
    }
    setLoading(false);
  };

  //Fetch sitelinks
  useEffect(async () => {
    await setSitelinks([]);
    await fetchSitelinksData();
    setPage(0);
    const data = await fetchBusinessDetailsByJsAccountId(token, jsAccId);
    if (data && data.status == 200) {
      setBrandName(data.brandName);
    }
  }, [id]);

  const handleSaveAPICall = async (sitelinks) => {
    const data = await saveSitelinks(token, sitelinks);
    return data;
  };

  const handleSaveSitelinks = async () => {
    const data = await handleSaveAPICall(selectedSitelinks);
    if (data && data.status == 200) {
      setError(false);
      setSnackbarMsg("Sitelinks saved");
    } else {
      setError(true);
      setSnackbarMsg("Error in saving sitelinks");
    }
    setSnackbarOpen(true);
  };

  const handleGenerateSitelinks = async (productFocus, url) => {
    setIsDrawerOpen(false);
    await handleSaveAPICall(selectedSitelinks);
    setLoading(true);
    const data = await generateSitelinks(token, id, productFocus, url);
    if (data && data.status == 200) {
      setGenerateError(false);
      setGenerateSnackbarMsg("Successfully generated sitelinks");
      await fetchSitelinksData();
    } else {
      setGenerateError(true);
      setGenerateSnackbarMsg("Error in generating sitelinks");
    }
    setPage(0);
    setLoading(false);
    setGenerateSnackbarOpen(true);
  };

  const handleCheckboxChange = (event, row) => {
    const isChecked = event.target.checked;

    setSelectedSitelinks((prevSitelinks) => {
      const updatedSitelinks = [...prevSitelinks];
      const index = updatedSitelinks.findIndex(
        (selectedRow) => selectedRow.id === row.id
      );
      if (index === -1) {
        updatedSitelinks.push({ ...row, selected: true });
      } else {
        updatedSitelinks[index] = { ...row, selected: isChecked };
      }

      return updatedSitelinks;
    });
  };

  const [selectedIndex, setSelectedIndex] = useState();

  const toggleUpdateDrawer = (row, index) => () => {
    setSelectedSitelinkForEdit(row);
    setSelectedIndex(index + page * rowsPerPage);
    setIsOpen(true);
  };

  const toggleGenerateDrawer = (open) => () => {
    setIsDrawerOpen(open);
  };

  const handleCloseIcon = () => {
    setIsOpen(false);
  };

  const handleUpdateSitelink = async (updatedSitelink) => {
    const updatedSitelinks = sitelinks.map((sitelink) =>
      sitelink.id === updatedSitelink.id ? updatedSitelink : sitelink
    );
    setSitelinks(updatedSitelinks);
    let newSitelinkArray = [];
    newSitelinkArray.push(updatedSitelink);
    const data = await handleSaveAPICall(newSitelinkArray);
    if (data && data.status == 200) {
      setError(false);
      setSnackbarMsg("Sitelink updated");
    } else {
      setError(true);
      setSnackbarMsg("Error in updating sitelink");
    }
    setSnackbarOpen(true);
  };

  const handleChangePage = (event, newPage) => {
   newPage = newPage - 1;
    setPage(newPage);
  };

  const [visibleRows, setVisibleRows] = useState([]);

  useEffect(() => {
    if (sitelinks.length > 0) {
      const startIndex = page * rowsPerPage;
      const endIndex = Math.min(startIndex + rowsPerPage, sitelinks.length);
      setVisibleRows(sitelinks.slice(startIndex, endIndex));
    } else {
      setVisibleRows([]);
    }
  }, [page, sitelinks]);

  const noValidLength = (row) => {
    if (
      row.text.length > 25 ||
      row.descriptionLine1.length > 35 ||
      row.descriptionLine2.length > 35
    ) {
      return true;
    } else {
      return false;
    }
  };


  return (
    <>
      <Grid container direction="row" style={{ padding: "0 2%" }}>
        <Grid
          item
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          xs={12}
        >
          <Grid item xs={8} sm={8} md={8} lg={9}>
            <Typography variant="subtitle2">
              Select at least 4 sitelinks
            </Typography>
          </Grid>
          <Grid item xs={4} sm={4} md={4} lg={3}>
            <JsTextAsButton
              onClick={toggleGenerateDrawer(true)}
              disabled={disableStructure}
            >
              + Generate Sitelinks
            </JsTextAsButton>
          </Grid>
        </Grid>

        <Grid
          item
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          xs={12}
          style={{
            // padding: "0 2%",
            backgroundColor: "#1E334E",
            margin: "1% 0",
          }}
        >
          <Grid item xs={10}>
            <IconButton
              aria-label="generate-new-sitelinks"
              onClick={() => handleGenerateSitelinks(productFocus, url)}
              disabled={disableStructure}
            >
              <Typography variant="subtitle2" style={{ color: "#fff" }}>
                Generate Sitelinks
              </Typography>
              <Tooltip title="Click to generate new sitelinks">
                <RefreshIcon fontSize="small" style={{ color: "#fff" }} />
              </Tooltip>
            </IconButton>
          </Grid>
          <Grid item xs={2}>
            <Typography
              variant="subtitle2"
              style={{ color: "#fff", float: "right", paddingRight: "4px" }}
            >
              Selected:{" "}
              {selectedSitelinks.length > 0
                ? selectedSitelinks.filter((row) => row.selected).length
                : 0}
              /6
            </Typography>
          </Grid>
        </Grid>

        {visibleRows && visibleRows.length > 0 ? (
          visibleRows.map((row, index) => (
            <>
              <Grid
                item
                container
                direction="row"
                justifyContent="space-between"
                alignContent="center"
                xs={12}
                className="sitelink-header"
              >
                <Grid item xs={10}>
                  {loading ? (
                    <Skeleton />
                  ) : (
                    <Typography fontSize="0.8125rem">
                      Sitelink {index + page * rowsPerPage + 1}
                      <IconButton
                        onClick={toggleUpdateDrawer(row, index)}
                        disabled={disableStructure}
                      >
                        <EditOutlinedIcon fontSize="small" />
                      </IconButton>
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={2}>
                  {loading ? (
                    <Skeleton />
                  ) : (
                    <Checkbox
                      key={index}
                      disabled={
                        disableStructure ||
                        noValidLength(row) ||
                        (selectedSitelinks.filter(
                          (selectedRow) => selectedRow.selected
                        ).length >= 6 &&
                          !selectedSitelinks.some(
                            (selectedRow) =>
                              selectedRow.id === row.id && selectedRow.selected
                          ))
                      }
                      checked={selectedSitelinks.some(
                        (selectedRow) =>
                          selectedRow.id === row.id && selectedRow.selected
                      )}
                      onChange={(e) => handleCheckboxChange(e, row)}
                      color="secondary"
                      style={{ float: "right" }}
                      size="small"
                    />
                  )}
                </Grid>
              </Grid>

              <Grid
                item
                container
                direction="row"
                rowSpacing={1}
                style={{ padding: "2%" }}
              >
                <Grid item xs={12}>
                  {loading ? (
                    <Skeleton />
                  ) : (
                    <>
                      <Typography
                        fontSize="0.8125rem"
                        className="sitelinkPrimaryColor"
                      >
                        Sitelink text &nbsp;
                        {/* <span className="sitelinkSecondaryColor">
                          ( Characters: {row.text.length} / 25):
                        </span> */}
                        <span className="sitelinkSecondaryColor">
                          ( Characters:&nbsp;
                          <Tooltip
                            title={
                              row.text.length > 25
                                ? "Sitelink text is more than 25 characters"
                                : ""
                            }
                            placement="right"
                          >
                            <span
                              style={{
                                color: row.text.length > 25 ? "red" : "inherit",
                              }}
                            >
                              {row.text.length}
                            </span>
                            /{25} )
                          </Tooltip>
                        </span>
                      </Typography>
                      <Typography
                        fontSize="0.8125rem"
                        className="sitelinkSecondaryColor"
                      >
                        {row.text}
                      </Typography>
                    </>
                  )}
                </Grid>
                <Grid item xs={12}>
                  {loading ? (
                    <Skeleton />
                  ) : (
                    <>
                      <Typography
                        fontSize="0.8125rem"
                        className="sitelinkPrimaryColor"
                      >
                        Description line 1 &nbsp;
                        <span className="sitelinkSecondaryColor">
                          ( Characters:&nbsp;
                          <Tooltip
                            title={
                              row.descriptionLine1.length > 35
                                ? "Description line 1 is more than 35 characters"
                                : ""
                            }
                            placement="right"
                          >
                            <span
                              style={{
                                color:
                                  row.descriptionLine1.length > 35
                                    ? "red"
                                    : "inherit",
                              }}
                            >
                              {row.descriptionLine1.length}
                            </span>
                            /{35} )
                          </Tooltip>
                        </span>
                      </Typography>
                      <Typography
                        fontSize="0.8125rem"
                        className="sitelinkSecondaryColor"
                      >
                        {row.descriptionLine1}
                      </Typography>
                    </>
                  )}
                </Grid>
                <Grid item xs={12}>
                  {loading ? (
                    <Skeleton />
                  ) : (
                    <>
                      <Typography
                        fontSize="0.8125rem"
                        className="sitelinkPrimaryColor"
                      >
                        Description line 2 &nbsp;
                        <span className="sitelinkSecondaryColor">
                          ( Characters:&nbsp;
                          <Tooltip
                            title={
                              row.descriptionLine2.length > 35
                                ? "Description line 2 is more than 35 characters"
                                : ""
                            }
                            placement="right"
                          >
                            <span
                              style={{
                                color:
                                  row.descriptionLine2.length > 35
                                    ? "red"
                                    : "inherit",
                              }}
                            >
                              {row.descriptionLine2.length}
                            </span>
                            /{35} )
                          </Tooltip>
                        </span>
                      </Typography>
                      <Typography
                        fontSize="0.8125rem"
                        className="sitelinkSecondaryColor"
                      >
                        {row.descriptionLine2}
                      </Typography>
                    </>
                  )}
                </Grid>
                <Grid item xs={12}>
                  {loading ? (
                    <Skeleton />
                  ) : (
                    <>
                      <Typography
                        fontSize="0.8125rem"
                        className="sitelinkPrimaryColor"
                      >
                        Final URL &nbsp;
                        <span className="sitelinkSecondaryColor">
                          ( Characters: &nbsp;
                          {row.finalUrl != null ? row.finalUrl.length : 0} ):
                        </span>
                        <span className="sitelinkUrlColor">
                          &nbsp; {row.finalUrl}
                        </span>
                      </Typography>
                      {/* <Typography variant="subtitle2" className="sitelinkUrlColor">
                    {row.finalUrl}
                  </Typography> */}
                    </>
                  )}

                  <br />
                  <Divider />
                </Grid>
              </Grid>
            </>
          ))
        ) : (
          <div className="structureContent">
            <Typography align="center">No data to show</Typography>
          </div>
        )}
        <Grid
          container
          direction="row"
          rowSpacing={1}
          justifyContent="center"
          alignItems="center"
          style={{ paddingTop: "2%" }}
        >
          {loading ? (
            ""
          ) : (
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Pagination
                count={totalPages}
                defaultPage={1}
                onChange={handleChangePage}
                showFirstButton
                showLastButton
              />
            </Grid>
          )}

          <Grid
            item
            container
            xs={12}
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            columnSpacing={2}
          >
            <Grid item>
              <Button
                variant="text"
                sx={{ textTransform: "none" }}
                disabled={
                  loading == true ||
                  (selectedSitelinks.length == 0 ? true : false) ||
                  disableStructure
                }
                onClick={() => handleSaveSitelinks()}
              >
                <SaveOutlinedIcon
                  sx={{ color: "#F58120", paddingRight: "2px" }}
                />
                Save
              </Button>
            </Grid>
            {/* <Grid item>
              <JsOrangeContainedBtn
                style={{ padding: "3% 5%" }}
                // onClick={NextComponent}
                // disabled={selectedCallouts.length == 0 ? true : false}
              >
                Next
              </JsOrangeContainedBtn>
            </Grid> */}
          </Grid>
        </Grid>
      </Grid>

      {/* Drawer for Updating sitelink */}
      <Drawer
        anchor="right"
        open={isOpen}
        onClose={handleCloseIcon}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 2 }}
      >
        <Box sx={{ width: 550 }}>
          <UpdateSitelink
            handleCloseIcon={handleCloseIcon}
            sitelink={selectedSitelinkForEdit}
            handleUpdateSitelink={handleUpdateSitelink}
            sitelinkIndex={selectedIndex}
          />
        </Box>
      </Drawer>
      {/* Drawer for generating sitelinks */}
      <Drawer
        anchor="right"
        open={isDrawerOpen}
        onClose={toggleGenerateDrawer(false)}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 2 }}
      >
        <Box sx={{ width: 550 }}>
          <GenerateSitelinks
            handleCloseDrawer={toggleGenerateDrawer}
            handleGenerateSitelinks={handleGenerateSitelinks}
            brandName={brandName}
          />
        </Box>
      </Drawer>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={error ? "error" : "success"}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMsg}
        </Alert>
      </Snackbar>

      <Snackbar
        open={generateSnackbarOpen}
        autoHideDuration={5000}
        onClose={handleGenerateSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleGenerateSnackbarClose}
          severity={generateError ? "error" : "success"}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {generateSnackbarMsg}
        </Alert>
      </Snackbar>
    </>
  );
}

const mapStateToProps = (state) => ({
  fetchSitelinksReducer: state.fetchSitelinksReducer,
  generateSitelinksReducer: state.generateSitelinksReducer,
  saveSitelinksReducer: state.saveSitelinksReducer,
  fetchBusinessDetailsByJsAccountIdReducer:
    state.fetchBusinessDetailsByJsAccountIdReducer,
});

const mapDispatchToProps = (dispatch) => ({
  fetchSitelinks: (token, id) => dispatch(fetchSitelinks(token, id)),
  generateSitelinks: (token, id, productFocus, pageUrl) =>
    dispatch(generateSitelinks(token, id, productFocus, pageUrl)),
  saveSitelinks: (token, sitelinks) =>
    dispatch(saveSitelinks(token, sitelinks)),
  fetchBusinessDetailsByJsAccountId: (token, id) =>
    dispatch(fetchBusinessDetailsByJsAccountId(token, id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Sitelinks);
